"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _entitiesReducer = _interopRequireDefault(require("./entitiesReducer"));

var _stagingReducer = _interopRequireDefault(require("./stagingReducer"));

var _Interactions = _interopRequireDefault(require("./Interactions"));

var _default = (0, _redux.combineReducers)({
  entities: _entitiesReducer.default,
  staging: _stagingReducer.default,
  interactions: _Interactions.default
});

exports.default = _default;
module.exports = exports.default;